let baseURL = '';
const env = process.env.NODE_ENV;
const envName = process.env.VUE_APP_NAME
let url = location.href;

if (url.indexOf('http://localhost') != -1 || url.indexOf('sit') != -1) {
    baseURL = 'https://server-order-api.yongxintao.com';
    //baseURL = 'https://server-api-sit.gymooit.cn';
    //baseURL = 'https://sever-test.yongxintao.com';
    //baseURL = 'http://api.yxt.com/';
}
else{
    baseURL = 'https://server-order-api.yongxintao.com';
    //baseURL = 'https://sever-test.yongxintao.com';
    //baseURL = 'http://api.yxt.com/';
    //baseURL = 'http://api.yxt.com/';
}
export default baseURL
